export enum GridDisplay {
  MOBILE,
  DESKTOP
}

export enum GridOrientation {
  VERTICAL,
  HORIZONTAL
}
